var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{attrs:{"aria-label":"Page navigation example"}},[_c('ul',{staticClass:"pagination"},_vm._l((parseInt(_vm.total)),function(n){return _c('li',{key:n,staticClass:"page-item",class:{active: n == _vm.active}},[_c('a',{staticClass:"page-link",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.navigate(n)}}},[_vm._v(_vm._s(n))])])}),0),_vm._v(" "),_c('p',[_vm._v("Exibindo página "+_vm._s(_vm.active)+" de "+_vm._s(_vm.total)+", total de "+_vm._s(_vm.totalRegistros)+" registros")])])
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/shared/Pagination.vue?vue&type=template&id=c184900c
// module id = null
// module chunks = 